import type { Work } from "@/types";
import WorkCard from "@/components/feature/WorkCard";

interface WorkGridProps {
  works: Work[];
  loading?: boolean;
  emptyText?: string;
  emptyAction?: React.ReactNode;
  columns?: 3 | 4;
}

export default function WorkGrid({
  works,
  loading = false,
  emptyText = "暂无符合筛选条件的影视作品",
  emptyAction,
  columns = 4,
}: WorkGridProps) {
  const gridClass =
    columns === 3
      ? "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5"
      : "grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 md:gap-5";

  if (loading) {
    return (
      <div className={gridClass}>
        {Array.from({ length: columns === 3 ? 6 : 8 }).map((_, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
          >
            <div className="aspect-[2/3] w-full animate-pulse bg-background-200" />
            <div className="space-y-2 p-3">
              <div className="h-4 w-3/4 animate-pulse rounded bg-background-200" />
              <div className="h-3 w-1/2 animate-pulse rounded bg-background-200" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (works.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-film-line text-3xl" />
        </span>
        <p className="mt-4 text-sm text-foreground-600 md:text-base">{emptyText}</p>
        {emptyAction && <div className="mt-5">{emptyAction}</div>}
      </div>
    );
  }

  return (
    <div className={gridClass}>
      {works.map((work) => (
        <WorkCard key={work.id} work={work} />
      ))}
    </div>
  );
}